import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCompare = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5 18H2V6H16",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 6H22V18H8",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 2L16 6L12 10",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 14L10 16L8 18L12 22",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		})
	]
});
export default SvgCompare;
